import { render, staticRenderFns } from "./ListarApresentantes.vue?vue&type=template&id=41cd2e1e"
import script from "./ListarApresentantes.vue?vue&type=script&lang=js"
export * from "./ListarApresentantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports